import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import About from './components/About';
import Project from './components/Project';
import Services from './components/Services';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

function App() {
	const [openbar, setOpenBar] = useState(false);

	return (
		<BrowserRouter>
			<Navbar setOpenBar={setOpenBar} openbar={openbar} />
			<Home openbar={openbar} />
			<About />
			<Project />
			<Services />
			<Footer />
		</BrowserRouter>
	);
}

export default App;
